import constants from '../constants';

export class Respond {
    /**
     * Constructor
     * @param {array} breakpoints Array of breakpoint objects {name: String, value: Int}
     */
    constructor(breakpoints) {
        this.breakpoints = [...breakpoints].sort(function(a, b){
            return a.value - b.value;
        });
    }

    /**
     * Gets a breakpoint object
     * @param {string} breakpointName The breakpoint name
    * @return {Object|False} The breakpoint object, or false if none was found
     */
    getBreakpoint (breakpointName) {
        const breakpoint = this.breakpoints.filter((currentBreakpoint) => {
            return currentBreakpoint.name === breakpointName;
        });

        if (breakpoint.length) {
            return breakpoint[0];
        }

        return false;
    }

    /**
     * Gets the next (larger) breakpoint object based on a current one
     * @param {Object} breakpoint Current breakpoint object
     * @return {Object|False} The next breakpoint, or false if none was found
     */
    getNextBreakpoint (breakpoint) {
        const currentIndex = this.breakpoints.indexOf(breakpoint);

        if (currentIndex === -1) {
            return false;
        }

        if (this.breakpoints.length < currentIndex + 1) {
            return false;
        }

        return this.breakpoints[currentIndex + 1];
    }

    /**
     * Will return true until device width matches breakpoint
     * @param {string} breakpointName The name of the breakpoint
     * @return {bool} True if matches
     */
    until (breakpointName) {
        const breakpoint = this.getBreakpoint(breakpointName);

        if (!breakpoint) {
            return false;
        }

        if (window.matchMedia('(max-width: ' + breakpoint.value + 'px)').matches) {
            return true;
        }

        return false;
    }

    /**
     * Will return true when device width matches, and is larger, than breakpint
     * @param {string} breakpointName The name of the breakpoint
     * @return {bool} True if matches
     */
    from (breakpointName) {
        const breakpoint = this.getBreakpoint(breakpointName);

        if (!breakpoint) {
            return false;
        }

        if (window.matchMedia('(min-width: ' + breakpoint.value + 'px)').matches) {
            return true;
        }

        return false;
    }

    /**
     * Will return true when the device width is at breakpoint but smaller than the next breakpoint
     * @param {string} breakpointName The name of the breakpoint
     * @return {bool} True if matches
     */
    to (breakpointName) {
        const breakpoint = this.getBreakpoint(breakpointName);

        if (!breakpoint) {
            return false;
        }
        
        const breakpointTo = this.getNextBreakpoint(breakpoint);

        if (!breakpointTo) {
            return false;
        }

        if (window.matchMedia('(min-width: ' + breakpoint.value + 'px) and (max-width: ' + (breakpointTo.value - 1) + 'px)').matches) {
            return true;
        }

        return false;
    }

};

const service = new Respond(constants.BREAKPOINTS);

export default service;


// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/Services/Respond.js